import React from "react";

import { useSavedSuppliers } from "lib/hooks/api/signals/useSavedSuppliers";
import { OpportunityEntityType } from "lib/types/graphQLEnums";
import { SaveToButton } from "../SaveToButton";

export const SaveSupplierButton = ({
  supplierGuid,
  supplierName,
}: {
  supplierGuid: string;
  supplierName?: string;
}) => {
  const { data: savedSuppliers } = useSavedSuppliers();
  const { partnerGuids, competitorGuids } = savedSuppliers || {
    partnerGuids: [],
    competitorGuids: [],
  };

  const timesIsPartner = partnerGuids.filter((guid) => guid === supplierGuid).length;
  const timesIsCompetitor = competitorGuids.filter((guid) => guid === supplierGuid).length;

  return (
    <SaveToButton
      entityType="supplier"
      entityIds={[supplierGuid]}
      savedCount={timesIsPartner + timesIsCompetitor}
      defaultOpportunityValues={{
        name: supplierName ?? "",
        assignedToId: window.currentUser?.guid,
        entities: [
          {
            entityId: supplierGuid,
            entityType: OpportunityEntityType.Organisation,
          },
        ],
      }}
    />
  );
};
